export default {
  token(state, token) {
    state.token = token;
  },
  changeSearchName(state, searchName) {
    state.searchName = searchName;
  },
  changeTempleName(state, templeName) {
	  state.templeName = templeName
  },
	CLIENT(state, client) {
		state.client = client;
  },
  LEDCODE(state, ledCode) {
  	state.ledCode = ledCode;
  },
   music(state,src){
      state.musicSrc = src
   },
   Time(state,time){
    state.musicTime = time
   }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js